export default __webpack_public_path__ + "static/media/exchange for Dark mode.9b9c301f.svg";